import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import Swal from "sweetalert2";
import "./ThemeCustomizables.css";

class ThemeCustomizables extends Component {
  state = {
    website_name: "",
    description: "",
    website_logo: null,
    loading_img: null,
    favicon: null,
    whatsapp_number: "",
    address: "",
    phone: "",
    email: "",
    social_link_1: "",
    social_link_2: "",
    social_link_3: "",
    social_link_4: "",

    preview_logo: "",
    preview_img: "",
    preview_favicon: "",

    loading: false,
  };

  API_BASE = axios.defaults.baseURL;
  PUBLIC_BASE = this.API_BASE.replace("/api", "");

  componentDidMount() {
    this.fetchExistingData();
  }

  componentWillUnmount() {
    ["preview_logo", "preview_img", "preview_favicon"].forEach((key) => {
      const val = this.state[key];
      if (val && val.startsWith("blob:")) {
        URL.revokeObjectURL(val);
      }
    });
  }

  fetchExistingData = async () => {
    try {
      this.setState({ loading: true });

      const res = await axios.get("/theme_customizables", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      const d = res?.data?.data;

      if (d) {
        this.setState({
          website_name: d.website_name || "",
          description: d.description || "",
          whatsapp_number: d.whatsapp_number || "",
          address: d.address || "",
          phone: d.phone || "",
          email: d.email || "",
          social_link_1: d.social_link_1 || "",
          social_link_2: d.social_link_2 || "",
          social_link_3: d.social_link_3 || "",
          social_link_4: d.social_link_4 || "",

          preview_logo: d.website_logo
            ? `${this.PUBLIC_BASE}/${d.website_logo}?t=${Date.now()}`
            : "",

          preview_img: d.loading_img
            ? `${this.PUBLIC_BASE}/${d.loading_img}?t=${Date.now()}`
            : "",

          preview_favicon: d.favicon
            ? `${this.PUBLIC_BASE}/${d.favicon}?t=${Date.now()}`
            : "",
        });
      }
    } catch (error) {
      console.error("Fetch Error:", error);
      Swal.fire("Error", "Failed to load data", "error");
    } finally {
      this.setState({ loading: false });
    }
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  createPreview = (file, key) => {
    if (!file) return;
    const preview = URL.createObjectURL(file);
    this.setState((prev) => {
      if (prev[key] && prev[key].startsWith("blob:")) {
        URL.revokeObjectURL(prev[key]);
      }
      return { [key]: preview };
    });
  };

  handleFileChange = (e) => {
    const file = e.target.files[0];
    this.setState({ website_logo: file });
    this.createPreview(file, "preview_logo");
  };

  handleFileChangeLoadingImage = (e) => {
    const file = e.target.files[0];
    this.setState({ loading_img: file });
    this.createPreview(file, "preview_img");
  };

  handleFileChangeFavicon = (e) => {
    const file = e.target.files[0];
    this.setState({ favicon: file });
    this.createPreview(file, "preview_favicon");
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    try {
      this.setState({ loading: true });

      let formData = new FormData();

      [
        "website_name",
        "description",
        "whatsapp_number",
        "address",
        "phone",
        "email",
        "social_link_1",
        "social_link_2",
        "social_link_3",
        "social_link_4",
      ].forEach((k) => formData.append(k, this.state[k]));

      if (this.state.website_logo)
        formData.append("website_logo", this.state.website_logo);

      if (this.state.loading_img)
        formData.append("loading_img", this.state.loading_img);

      if (this.state.favicon)
        formData.append("favicon", this.state.favicon);

      const res = await axios.post("/theme_customizables", formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
        },
      });

      Swal.fire({
        icon: "success",
        title: "Success",
        text: res.data.message,
        timer: 2000,
        showConfirmButton: false
      });

      this.fetchExistingData();
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Save failed", "error");
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const {
      website_name, description, whatsapp_number, address,
      phone, email, social_link_1, social_link_2,
      social_link_3, social_link_4, preview_logo,
      preview_img, preview_favicon, loading,
    } = this.state;

    return (
      <div className="pc-container theme-page">
        <div className="pc-content">
          <div className="theme-shell">
            
            {/* Topbar */}
            <div className="theme-topbar">
              <div>
                <div className="theme-breadcrumb">
                  <span>Management</span>
                  <i className="ph ph-caret-right" />
                  <span>Settings</span>
                  <i className="ph ph-caret-right" />
                  <strong>Theme Customization</strong>
                </div>
                <h2 className="theme-title">Theme Customization</h2>
                <p className="theme-subtitle">
                  Configure your website branding, contact information, and social links.
                </p>
              </div>
            </div>

            {/* Main Form Card */}
            <form onSubmit={this.handleSubmit}>
              <div className="theme-card">
                <div className="theme-card-header">
                  <h4>Global Website Settings</h4>
                </div>

                <div className="theme-card-body">
                  <div className="theme-layout-grid">
                    
                    {/* Left Column: Form Fields */}
                    <div className="theme-grid-col-left">
                      
                      {/* Section 1: Basic Info */}
                      <div className="theme-section">
                        <h5 className="theme-section-title">
                          <i className="ph ph-info" /> Basic Information
                        </h5>
                        <div className="row g-3">
                          <div className="col-12">
                            <div className="theme-form-group">
                              <label>Website Name</label>
                              <div className="theme-input-wrap">
                                <i className="ph ph-browser" />
                                <input
                                  type="text"
                                  name="website_name"
                                  className="theme-input"
                                  placeholder="Enter your website name"
                                  value={website_name}
                                  onChange={this.handleChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12">
                            <div className="theme-form-group mb-0">
                              <label>Website Description</label>
                              <div className="theme-input-wrap">
                                <i className="ph ph-text-align-left textarea-icon" />
                                <textarea
                                  name="description"
                                  className="theme-input theme-textarea"
                                  placeholder="Enter a brief description for SEO and footer display"
                                  value={description}
                                  onChange={this.handleChange}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Section 2: Contact Details */}
                      <div className="theme-section">
                        <h5 className="theme-section-title">
                          <i className="ph ph-address-book" /> Contact Details
                        </h5>
                        <div className="row g-3">
                          <div className="col-md-6">
                            <div className="theme-form-group mb-0">
                              <label>Phone Number</label>
                              <div className="theme-input-wrap">
                                <i className="ph ph-phone" />
                                <input
                                  name="phone"
                                  className="theme-input"
                                  placeholder="+1 (555) 000-0000"
                                  value={phone}
                                  onChange={this.handleChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="theme-form-group mb-0">
                              <label>WhatsApp Number</label>
                              <div className="theme-input-wrap">
                                <i className="ph ph-whatsapp-logo" />
                                <input
                                  name="whatsapp_number"
                                  className="theme-input"
                                  placeholder="+1 (555) 000-0000"
                                  value={whatsapp_number}
                                  onChange={this.handleChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="theme-form-group mb-0">
                              <label>Email Address</label>
                              <div className="theme-input-wrap">
                                <i className="ph ph-envelope" />
                                <input
                                  type="email"
                                  name="email"
                                  className="theme-input"
                                  placeholder="support@domain.com"
                                  value={email}
                                  onChange={this.handleChange}
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="theme-form-group mb-0">
                              <label>Physical Address</label>
                              <div className="theme-input-wrap">
                                <i className="ph ph-map-pin" />
                                <input
                                  type="text"
                                  name="address"
                                  className="theme-input"
                                  placeholder="123 Main St, City"
                                  value={address}
                                  onChange={this.handleChange}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Section 3: Social Links */}
                      <div className="theme-section">
                        <h5 className="theme-section-title">
                          <i className="ph ph-share-network" /> Social Links
                        </h5>
                        <div className="row g-3">
                          {[
                            { id: 1, icon: "ph-facebook-logo", placeholder: "Facebook URL" },
                            { id: 2, icon: "ph-twitter-logo", placeholder: "Twitter / X URL" },
                            { id: 3, icon: "ph-instagram-logo", placeholder: "Instagram URL" },
                            { id: 4, icon: "ph-linkedin-logo", placeholder: "LinkedIn URL" }
                          ].map((social, index) => (
                            <div className="col-md-6" key={social.id}>
                              <div className="theme-form-group mb-0">
                                <label>Social Link {index + 1}</label>
                                <div className="theme-input-wrap">
                                  <i className={`ph ${social.icon}`} />
                                  <input
                                    name={`social_link_${social.id}`}
                                    className="theme-input"
                                    placeholder={social.placeholder}
                                    value={this.state[`social_link_${social.id}`]}
                                    onChange={this.handleChange}
                                  />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                    </div>

                    {/* Right Column: Brand Assets (Images) */}
                    <div className="theme-grid-col-right">
                      <div className="theme-brand-assets">
                        <h5 className="theme-section-title">
                          <i className="ph ph-palette" /> Brand Assets
                        </h5>

                        {/* Main Logo */}
                        <div className="theme-uploader-group">
                          <div className="theme-uploader-header">
                            <label>Website Logo</label>
                            <span>Recommended: 500x150px</span>
                          </div>
                          <label className="theme-img-dropzone img-box-rect">
                            <input type="file" className="d-none" accept="image/*" onChange={this.handleFileChange} />
                            {preview_logo ? (
                              <>
                                <img src={preview_logo} alt="Logo" className="theme-img-preview" />
                                <div className="theme-img-overlay">
                                  <i className="ph ph-camera" />
                                  <span>Change Logo</span>
                                </div>
                              </>
                            ) : (
                              <div className="theme-img-placeholder">
                                <i className="ph ph-image" />
                                <span>Click to upload Logo</span>
                              </div>
                            )}
                          </label>
                        </div>

                        {/* Loading Image */}
                        <div className="theme-uploader-group">
                          <div className="theme-uploader-header">
                            <label>Loading Image (Preloader)</label>
                            <span>Transparent GIF/PNG</span>
                          </div>
                          <label className="theme-img-dropzone img-box-rect">
                            <input type="file" className="d-none" accept="image/*" onChange={this.handleFileChangeLoadingImage} />
                            {preview_img ? (
                              <>
                                <img src={preview_img} alt="Loader" className="theme-img-preview" />
                                <div className="theme-img-overlay">
                                  <i className="ph ph-camera" />
                                  <span>Change Image</span>
                                </div>
                              </>
                            ) : (
                              <div className="theme-img-placeholder">
                                <i className="ph ph-spinner-gap" />
                                <span>Click to upload Preloader</span>
                              </div>
                            )}
                          </label>
                        </div>

                        {/* Favicon */}
                        <div className="theme-uploader-group text-center">
                          <div className="theme-uploader-header" style={{ justifyContent: 'center', marginBottom: '14px' }}>
                            <label>Favicon</label>
                          </div>
                          <label className="theme-img-dropzone img-box-square">
                            <input type="file" className="d-none" accept="image/*" onChange={this.handleFileChangeFavicon} />
                            {preview_favicon ? (
                              <>
                                <img src={preview_favicon} alt="Favicon" className="theme-img-preview" />
                                <div className="theme-img-overlay">
                                  <i className="ph ph-camera" />
                                </div>
                              </>
                            ) : (
                              <div className="theme-img-placeholder">
                                <i className="ph ph-app-window" />
                              </div>
                            )}
                          </label>
                          <span className="d-block mt-2" style={{ fontSize: '11px', color: '#94a3b8' }}>Must be exactly 32x32px (.png, .ico)</span>
                        </div>

                      </div>
                    </div>

                  </div>
                </div>

                <div className="theme-card-footer">
                  <button type="submit" className="bookly-primary-btn" disabled={loading}>
                    {loading ? (
                      <><span className="spinner-border spinner-border-sm" /> Saving Changes...</>
                    ) : (
                      <><i className="ph ph-floppy-disk" /> Save Customization</>
                    )}
                  </button>
                </div>

              </div>
            </form>

          </div>
        </div>
      </div>
    );
  }
}

export default ThemeCustomizables;
